<template>
  <modal name="atmObstHstrListModal" :width="500" :height="'100%'" :clickToClose="false"
    @before-open="beforeOpen"
    @opened="opened"
  >
    <div id="div_atmObstHstrListModal" class="popup boundary">
      <div class="pop_tit">
        <span>{{ title }}</span>
        <a href="javascript:void(0);" title="close" class="pop_close" @click="close">close</a>
      </div>
      <div class="pop_con_wrap" style="padding: 0">
        <div class="pop_con">
          <div class="pop_con_bg" style="padding: 0">
            <!-- <AtmObstHstr :isModal="true" /> -->

            <component :is="comp" v-bind="propData" @jobDone="close"/>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>

export default {
  name: 'AtmObstHstrListModal',
  components: {
  },
  data: () => ({
    comp: {},
    propData: {},
    title: ''
  }),
  computed: {
    getRoutePath () {
      return this.$route.path
    }
  },
  created () {

  },
  mounted () {

  },
  watch: {
    getRoutePath (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.close()
      }
    }
  },
  methods: {
    beforeOpen ({ params }) {
      this.comp = params.comp
      this.propData = { ...params.propData }
      this.title = params.title
    },
    opened () {
      let popLeft = (($(window).width() - $('#div_atmObstHstrListModal').outerWidth()) / 2)
      let popTop = (($(window).height() - $('#div_atmObstHstrListModal').outerHeight()) / 2)
      if (popLeft < 0) popLeft = 0
      if (popTop < 0) popTop = 0
      $('#popupMask').fadeIn()
      $('#div_atmObstHstrListModal').css({'left': popLeft, 'top': popTop}).fadeIn().addClass('on')
    },
    closed () {
      $('#pop_up').fadeOut().removeClass('on')
      $('#popupMask').fadeOut()
    },
    close () {
      this.closed()
      this.$emit('close')
      this.$modal.hide('atmObstHstrListModal')
    }
  }
}
</script>

<style scoped>
.popup.boundary {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/customerCare/AtmObstHstrListModal.vue